import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { MapPin } from 'lucide-react';
import { Button } from '@shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@shared/components/ui/dialog';

interface WalkInDialogProps {
  open: boolean;
  onClose: () => void;
  date: Date;
  partySize: number;
  service?: string | null;
  locale?: Locale;
}

export function WalkInDialog({
  open,
  onClose,
  date,
  partySize,
  service,
  locale,
}: WalkInDialogProps) {
  const { t } = useTranslation('booking');

  const formattedDate = format(date, 'EEEE d, MMMM', { locale });
  const serviceLabel = service
    ? t(`FILTER_STRING_${service.toUpperCase()}`)
    : null;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md bg-card text-foreground">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
              <MapPin className="text-primary" size={28} />
            </div>
          </div>
          <DialogTitle className="text-center text-xl">
            {t('WALK_IN_ONLY')}
          </DialogTitle>
        </DialogHeader>

        <div className="text-center space-y-1 text-sm text-foreground">
          <div>
            {partySize} {t('FILTER_STRING_PEOPLE2')}
          </div>
          <div className="capitalize">{formattedDate}</div>
          {serviceLabel && <div>{serviceLabel}</div>}
        </div>

        <p className="text-foreground/70 text-sm text-center">
          {t('CALENDAR_DIALOG_WALK_IN_TEXT_2')}
        </p>

        <Button className="w-full" onClick={onClose}>
          {t('WALK_IN_OK')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
